module.exports = __webpack_public_path__ + "static/media/depositar-a-plazo.5cdb0bc8.svg";